/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { excelControllerPigExcelUpload } from '../fn/excel/excel-controller-pig-excel-upload';
import { ExcelControllerPigExcelUpload$Params } from '../fn/excel/excel-controller-pig-excel-upload';
import { PigExcelResultDto } from '../models/pig-excel-result-dto';

@Injectable({ providedIn: 'root' })
export class ExcelService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `excelControllerPigExcelUpload()` */
  static readonly ExcelControllerPigExcelUploadPath = '/api/excel/pig';

  /**
   * 엑셀로 받은 돼지 데이터를 일괄 업로드합니다.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelControllerPigExcelUpload()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  excelControllerPigExcelUpload$Response(params: ExcelControllerPigExcelUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<PigExcelResultDto>> {
    const obs = excelControllerPigExcelUpload(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 엑셀로 받은 돼지 데이터를 일괄 업로드합니다.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelControllerPigExcelUpload$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  excelControllerPigExcelUpload(params: ExcelControllerPigExcelUpload$Params, context?: HttpContext): Observable<PigExcelResultDto> {
    const resp = this.excelControllerPigExcelUpload$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PigExcelResultDto>): PigExcelResultDto => r.body)
    );
  }

}
